import { VpStarRating } from '@vtmn-play/react';
import clsx from 'clsx';
import genericImage from '../assets/genericImage.jpeg';
import { SkeletonLine } from '../skeleton/Skeleton';
import styles from './styles.module.scss';

export const SkeletonSmCard = () => (
  <div className={styles['spo-skeleton-sm-card']}>
    <SkeletonLine className={styles['spo-poster-skeleton-line']} />
    <div className={styles['spo-skeleton-image']}>
      <img src={genericImage} alt="super model placeholder" />
    </div>
    <SkeletonLine className={styles['spo-poster-skeleton-line']} />
    <SkeletonLine className={styles['spo-poster-skeleton-line']} />
    <SkeletonLine className={styles['spo-poster-skeleton-line']} />
  </div>
);

export const SkeletonBenefit = () => (
  <div className={styles['spo-skeleton-benefit']}>
    <div className={styles['spo-skeleton-benefit-label']} />
    <VpStarRating score={0} className={styles['spo-skeleton-benefit-star']} />
  </div>
);

export const SmSkeletonTable = () => (
  <div className={clsx(styles['spo-skeleton-table'], styles['spo-pulse'])}>
    <div className={styles['spo-skeleton-sm']}>
      <div className={styles['spo-skeleton-sm-title']} />
      <div className={styles['spo-skeleton-sm-title']} />
      <SkeletonBenefit />
      <SkeletonBenefit />
      <SkeletonBenefit />
      <SkeletonBenefit />
    </div>
    <SkeletonSmCard />
  </div>
);

export const PosterSkeleton = () => (
  <div data-testid="poster-skeleton" className={styles['spo-poster-skeleton']}>
    <SmSkeletonTable />
    <SmSkeletonTable />
    <SmSkeletonTable />
  </div>
);
